
import React from 'react';
import ReactSelect from 'react-select';
import {css} from 'emotion';

export const FormEditBlockFieldType = function (props) {

  if (!props.block()?.component)
    return (<></>);

  return (<>
    <label
      className={css`
        display: flex;
        gap: 8px;
        padding: 8px;
        border-style: solid;
        border-width: 1px;
        border-color: #d1d5db;
      `}
    >
      <div
        className={css`
          display: grid;
          place-content: start center;
          place-items: start center;
        `}
      >
        Type
      </div>
      <div
        className={css`
          display: grid;
          place-content: stretch;
          place-items: center;
          width: 100%;
        `}
      >
        <ReactSelect
          styles={{
            container: (baseStyles, state) => ({
              ...baseStyles,
              width: '100%',
            }),
          }}
          value={{label: props.block()?.component ?? '', value: props.block()?.component ?? ''}}
          onChange={(val) => {
            props.block({
              ...props.block(),
              component: val.value,
            });
          }}
          options={[
            {value: 'DropdownInput', label: 'DropdownInput'},
            ...(props.noGroup ? [] : [{value: 'Group', label: 'Group'}]),
            {value: 'HTML', label: 'HTML'},
            {value: 'MultiLineTextInput', label: 'MultiLineTextInput'},
            {value: 'OpinionScaleInput', label: 'OpinionScaleInput'},
            {value: 'SingleLineTextInput', label: 'SingleLineTextInput'},
          ]}
        />
      </div>
    </label>
  </>);

};
